import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";
import {
  HiUserPlus,
  HiUserGroup,
  HiUser,
  HiEnvelope,
  HiBanknotes,
  HiKey,
  HiLockClosed,
  HiPlus,
} from "react-icons/hi2";

import adminUi from "../UI/AdminUi.module.css";
import Spinner from "../UI/Spinner";
import { alertActions } from "../../store/alert-slice";
import { createAccount } from "../../api/api";
import { getAuthToken } from "../../util/authToken";

const CreateAccount = () => {
  const [showSpinner, setShowSpinner] = useState(false);
  const dispatch = useDispatch();
  const nameRef = useRef();
  const usernameRef = useRef();
  const emailRef = useRef();
  const balanceRef = useRef();
  const secondEmailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();

  const submitHandler = async (e) => {
    e.preventDefault();
    setShowSpinner(true);

    const data = {
      name: nameRef.current.value,
      username: usernameRef.current.value || undefined,
      email: emailRef.current.value,
      secondEmail: secondEmailRef.current.value,
      balance: balanceRef.current.value,
      password: passwordRef.current.value,
      passwordConfirm: passwordConfirmRef.current.value,
    };

    const res = await createAccount(getAuthToken(), data);

    if (res.status === "success") {
      dispatch(
        alertActions.setState({ message: res.message, status: res.status })
      );
    } else {
      dispatch(
        alertActions.setState({ message: res.message, status: "error" })
      );
    }

    setShowSpinner(false);
  };

  return (
    <div className={adminUi.page}>
      <h1 className={adminUi.pageTitle}>
        <HiUserPlus className={adminUi.pageTitleIcon} aria-hidden />
        Create account
      </h1>
      <p className={adminUi.pageLead}>
        Register a new customer with starting balance and credentials.
      </p>
      <motion.form
        className={adminUi.formCard}
        onSubmit={submitHandler}
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
      >
        {showSpinner && <Spinner />}
        <h2 className={adminUi.formTitle}>
          <HiUserGroup className={adminUi.formTitleIcon} aria-hidden />
          New customer
        </h2>
        <div className={adminUi.field}>
          <label htmlFor="new-name">Name</label>
          <div className={adminUi.inputWrap}>
            <HiUser className={adminUi.fieldIcon} aria-hidden />
            <input id="new-name" type="text" ref={nameRef} />
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="new-username">Username (auto-generated if blank)</label>
          <div className={adminUi.inputWrap}>
            <HiUser className={adminUi.fieldIcon} aria-hidden />
            <input id="new-username" type="text" ref={usernameRef} />
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="new-email">Email</label>
          <div className={adminUi.inputWrap}>
            <HiEnvelope className={adminUi.fieldIcon} aria-hidden />
            <input id="new-email" type="email" ref={emailRef} />
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="new-second-email">Second email</label>
          <div className={adminUi.inputWrap}>
            <HiEnvelope className={adminUi.fieldIcon} aria-hidden />
            <input id="new-second-email" type="email" ref={secondEmailRef} />
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="new-balance">Balance</label>
          <div className={adminUi.inputWrap}>
            <HiBanknotes className={adminUi.fieldIcon} aria-hidden />
            <input id="new-balance" type="number" ref={balanceRef} />
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="new-password">Password</label>
          <div className={adminUi.inputWrap}>
            <HiKey className={adminUi.fieldIcon} aria-hidden />
            <input id="new-password" type="password" ref={passwordRef} />
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="new-password-confirm">Confirm password</label>
          <div className={adminUi.inputWrap}>
            <HiLockClosed className={adminUi.fieldIcon} aria-hidden />
            <input
              id="new-password-confirm"
              type="password"
              ref={passwordConfirmRef}
            />
          </div>
        </div>
        <div className={adminUi.actions}>
          <button className={adminUi.btnPrimary} type="submit">
            <HiPlus className={adminUi.btnPrimaryIcon} aria-hidden />
            Create account
          </button>
        </div>
      </motion.form>
    </div>
  );
};

export default CreateAccount;
